import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'
import styles from './header-item.styl'

export default class HeaderItem extends Component {
  static propTypes = {
    rightItem: PropTypes.any,
    sizeUpIcon: PropTypes.bool,
    link: PropTypes.bool,
    onClick: PropTypes.func,
    captionKey: PropTypes.string,
    caption: PropTypes.string,
    ico: PropTypes.string,
    to: PropTypes.string,
  }

  renderContent = () => {
    const {
      captionKey,
      sizeUpIcon,
      rightItem,
      caption,
      ico,
    } = this.props

    return (
      <div className={styles.wrap}>
        <i className={`ico ico--${ico} ${styles.ico} ${sizeUpIcon ? styles.bigger : ''}`} />
        <p className={styles.caption}>
          <FormattedMessage id={captionKey} defaultMessage={caption} />
        </p>
        {rightItem && <div className={styles.rightItem}>
          {rightItem}
        </div>}
      </div>
    )
  }

  render() {
    const {
      to,
      link,
      onClick,
    } = this.props

    return link ? (
      <Link to={to}>
        {this.renderContent()}
      </Link>
    ) : (
      <div onClick={onClick}>
        {this.renderContent()}
      </div>
    )
  }
}
